import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    SwitchTableAlert: {
        display: 'flex',
        alignItems: 'center',
        padding: '12px',
        "background": "#FFFFFF",
        position: 'absolute',
        "boxShadow": "0px 4px 15px rgba(249, 98, 83, 0.2), inset 4px 0px 0px #6E7187",
        "borderRadius": "8px",
        width: '315px'
    },
    TableIcon: {
        "width": "36px",
        "height": "36px",
        "background": "#e14954",
        "borderRadius": "8px",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '10px'
    },
    Main: {
        marginRight: '50px',
        '&>div:first-child': {
            "fontStyle": "normal",
            "fontWeight": "700",
            "fontSize": "14px",
            "lineHeight": "17px",
            "textTransform": "uppercase",
            "color": "#271D1C",
            marginBottom: '4px'
        },
        '&>div:last-child': {
            "fontStyle": "normal",
            "fontWeight": "500",
            "fontSize": "12px",
            "lineHeight": "15px",
            "color": "rgba(13, 13, 17, 0.5)"
        }
    },
    CloseBtn: {
        "width": "32px",
        "height": "32px",
        "background": "rgba(13, 13, 17, 0.05)",
        borderRadius: '50%',
        border: 'none',
        boxShadow: 'none',
        cursor: 'pointer',
        "fontSize": "28px",
        "padding": "0",
        "lineHeight": "32px",
        '& i': {
            color: '#6E7187'
        }
    }
}));
